module.exports = __webpack_public_path__ + "static/media/logo-light.4aaf6e79.svg";